// extracted by mini-css-extract-plugin
module.exports = {"root":"Asdom_root___CmJN","variant1":"Asdom_variant1__15q_M","variant2":"Asdom_variant2__1di1u"};